export const batch = <T>(items: T[], count = 5) => {
    const batched: Array<T[]> = [];

    for (let i = 0; i < items.length; i += count) {
        batched.push(items.slice(i, i + count));
    }

    return batched;
};
